import { Button } from '@mui/material'

export const ResetButton = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button variant="outlined" color="primary" type="reset" sx={{ minWidth: 100 }}>
        Reset
      </Button>
    </div>
  )
}
